<template>
<div class="join-style" id="second-floor">
    <div class="iner-box">
        <div class="title"><img src="https://media2.imgyb.xyz/media/v1/image/ac590794809a1846eb05b9ca21b1edab.png" alt=""></div>
        <div class="cont-row first">
            <div class="lab">方式1：</div>
            <div class="flex-cont">通过#加拿大的秋#专题页面，发布视频或图文帖子，即成功参与。</div>
        </div>
        <div class="cont-row">
            <div class="lab">方式2：</div>
            <div class="flex-cont">在约克论坛任意版块发布主题帖，帖子标题带#加拿大的秋#，发布视频或图文帖子，即成功参与。</div>
        </div>
        <div class="detail-enter"><a href="https://forum.yorkbbs.ca/detail/9ec5c0f0-3745-4dbc-ace8-7825fb5ba170?topic=chat">活动详情</a> <i class="yk yk-arrow-right"></i></div>
    </div>
    
</div>
</template>
<script>
export default {
    name:'JoinStyle',
    data(){
        return  {

        }
    }
}
</script>
<style lang="less" scoped>
.join-style{
    background: #FFF3E1; border-radius: 20px; padding: 15px; margin-bottom: 30px;
    .iner-box{
        position: relative; border-radius: 20px; padding:25px 25px 20px; background: url(https://media5.imgyb.xyz/media/v1/image/a02f728675fc7b87b7c43330b2ee6273.png) no-repeat right top #fff; 
        .title{
                margin-bottom: 20px;
                img{display: block;max-width: 100%;}
        }
        .cont-row{
            align-items: flex-start; font-size: 20px; line-height: 34px;
            &.first{margin-bottom: 8px;}
            .lab{position:relative;
                &:after{content: ''; position: absolute; left: 0; bottom: 0; width: 40px; height: 9px; background:rgba(255,167,109,0.50);}
            }
        }
       .detail-enter{position: absolute; right: 25px ; bottom: 20px;color: #E66600;
            a{text-decoration: underline;}
            i{font-size: 14px;}
       }
    }
}
@media screen and (max-width:768px){
    .join-style{
        .iner-box{
            .cont-row{
                align-items: flex-start; font-size: 17px; line-height: 28px;
                
            }
         }
    }
}
</style>